import split_filename from "js/files/naming/split_filename"
import composition from "rfuncs/functions/composition"
import last from "rfuncs/functions/last"

export default composition(split_filename, last)
